import request from '../utils/request'
const serviceName = 'prjTypeModel'

export function getTree(data) {
  return request({
    url:`/${serviceName}/getTree`,
    method:'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/prjTypeModel.js